class TopBannerSlider extends HTMLElement {
	constructor() {
		super();

		this.swiperInstance = null;
		this.dataId = null;
		this.speed = DEFAULT_SLIDER_SPEED || 1000;
		this.delay = 1000;
		this.slideCount = 0;
	}

	connectedCallback() {
		this.dataId = this.getAttribute('data-id');
		this.speed = this.getAttribute('data-speed');
		this.delay = this.getAttribute('data-delay');
		this.slideCount = this.getAttribute('data-slidecount');

		this.initSwiper();
		this.observeHiddenSlides();
	}

	disconnectedCallback() {
		this.slideObserver?.disconnect();
		this.destroySwiper();
	}

	showContainer() {
		this.classList.remove('opacity-0');
	}

	initSwiper() {
		if (this.slideCount == 1) {
			console.info('Swiper not initialized. Only one child element.');
			this.showContainer();

			return null;
		}

		this.swiperInstance = new Swiper(this, {
			speed: this.speed,
			loop: true,
			slidesPerView: 1,
			direction: 'vertical',
			autoplay: {
				reverseDirection: true,
				delay: this.delay
			},
			autoHeight: true,
			preventInteractionOnTransition: true,
			on: {
				init: () => this.showContainer()
			}
		});
	}

	observeHiddenSlides() {
		this.slideObserver = new MutationObserver((mutations) => {
			mutations.forEach(({ target }) => {
				if (target.hidden && target.classList.contains('swiper-slide')) {
					this.removeHiddenSlide(target);
				}
			});
		});

		this.slideObserver.observe(this, {
			subtree: true,
			attributes: true,
			attributeFilter: ['hidden']
		});
	}

	removeHiddenSlide(slide) {
		if (this.swiperInstance) {
			const slideIndex = this.swiperInstance.params.loop
				? Number(slide.dataset.swiperSlideIndex)
				: this.swiperInstance.slides.indexOf(slide);
			if (Number.isInteger(slideIndex) && slideIndex > -1) {
				this.swiperInstance.removeSlide(slideIndex);
			}
			if (this.swiperInstance.slides.length <= 1) this.destroySwiper();
		} else {
			slide.remove();
		}

		if (!this.querySelector('.swiper-slide')) {
			this.closest('.announcement-bar-section')?.setAttribute('hidden', '');
		}
	}

	destroySwiper() {
		if (this.swiperInstance) {
			try {
				if (this.swiperInstance.destroyed) {
					console.info('Swiper already destroyed');

					this.swiperInstance = null;
					return null;
				}
				this.swiperInstance.destroy(true, true);
				this.swiperInstance = null;
			} catch (error) {
				console.error('Error destroying Swiper:', error);
				this.swiperInstance = null; // Fallback
			}
		} else {
			console.log('No Swiper instance to destroy');
		}
	}
}

customElements.define('top-banner-slider-controller', TopBannerSlider);
